module.exports = __webpack_public_path__ + "img/document-deletion.9c1d2987.svg";